import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppAuthentication from './Components/_Authentication/AppAuthentication';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
    <AppAuthentication />
  </React.StrictMode>
);
reportWebVitals();
